<section class="cbanner overflow-hidden position-relative">
	<div class="container">
		<!-- <canvas
			id="canvas"
			class="img-globe"
			data-aos="zoom-in"
			data-aos-duration="500"
			data-aos-delay="100"
		></canvas> -->
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<!-- <img
					class="img-globe floatimg"
					src="{{ baseUrl }}/img/3D-images/studio.png"
					alt="Branding Studio"
					width=""
					height=""
					loading="lazy"
				/> -->
				<div id="spline-container">
					<!-- <canvas id="canvas" class="floatimg"></canvas> -->
					<!-- <div #canvas style="width: 100%; height: 100%" class="floatimg"></div> -->
					<spline-viewer
						class="floatimg"
						url="https://prod.spline.design/9TkLX7Ik6tbNUBSS/scene.splinecode"
					></spline-viewer>
				</div>
				<div class="banner vh-100">
					<div
						class="d-flex flex-column justify-content-center h-100 align-items-start"
					>
						<div
							class="contentbl"
							data-aos="fade-up"
							data-aos-duration="1000"
							data-aos-delay="100"
						>
							<h1 class="size90 textcolor3">
								When your vision needs a
								<span class="light size90 textcolor1">
									<span class="barcely text-capitalize"> team </span> by your
									side.</span
								>
							</h1>
						</div>
					</div>
				</div>
				<div class="position-absolute banner-left-content content-left">
					<div class="d-flex flex-column justify-contente-center left-content2">
						<p class="size24 textcolor1 lufgaregular">
							If you’re looking for a detail obsessed,
						</p>
						<p class="size24 textcolor1 lufgaregular">
							marketing-savvy design team
						</p>
						<p class="size24 textcolor1 lufgaregular">
							that elevate your brand and business…
						</p>
						<h2 class="p3 lufgabold textcolor1 size24">
							Then you’re in the right place!
						</h2>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- Banner ends-->
<!--  About us starts -->
<section class="aboutbrand mtrem5">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
			>
				<div class="about-brand mrem55">
					<h2 class="size55 weight300 light">
						<span class="textcolor3">At Pixtar, we believe </span>
						<span class="textcolor1">
							design isn’t just about
							<span class="barcely"> Aesthetics</span> —it’s about creating
							harmony, inspiring trust, and building connections.</span
						>
						<span class="textcolor3"> We’re a team of</span>
						<span class="textcolor1">
							creators, thinkers, and dreamers, rooted in Dubai-UAE
						</span>
						<span class="textcolor3">
							but designing for a global audience.</span
						>
					</h2>
				</div>
			</div>
		</div>
	</div>
</section>
<!--  About us starts -->
<section class="care-section">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
			>
				<div class="care">
					<h3 class="fontsize14 semibold">WHAT DRIVES OUR DESIGN</h3>
					<p class="size32 mb30 textcolor1">We Care About…</p>
					<img
						class="mb30 w-100"
						src="{{ baseUrl }}/img/about-us/careimg.jpg"
						alt="Design Studio"
						width=""
						height=""
						loading="lazy"
					/>
				</div>
				<div class="row">
					<div class="col-md-4 col-sm-6">
						<div class="box">
							<h3 class="size24 textcolor1 semibold mb-3">You</h3>
							<p class="size20 textcolor1">
								We’re here to make your life easier and to bring excitement to
								<span class="lufgasemibold"
									>launching your brand or website.</span
								>
								From the first design concept to a smooth launch, we handle
								every detail, so you can
								<span class="lufgasemibold">focus on what matters most.</span>
							</p>
						</div>
					</div>
					<div class="col-md-4 col-sm-6">
						<div class="box">
							<h3 class="size24 textcolor1 semibold mb-3">Your Audience</h3>
							<p class="size20 textcolor1">
								Our designs don’t just look good
								<span class="lufgasemibold">—they connect.</span> We create
								engaging, easy-to-navigate experiences that leave a lasting
								impression,<span class="lufgasemibold">
									making sure your audience feels right at home on every
									page.</span
								>
							</p>
						</div>
					</div>
					<div class="col-md-4 col-sm-6">
						<div class="box">
							<h3 class="size24 textcolor1 semibold mb-3">
								Your Business Goals
							</h3>
							<p class="size20 textcolor1">
								<span class="lufgasemibold">Great design solves problems,</span>
								from building brand loyalty to driving conversions. We’re here
								to help you
								<span class="lufgasemibold">
									grow, boost your impact, and reach more people </span
								>through design that works as hard as you do.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- deserve section starts-->
<section class="deserve-section mrem55">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-12 col-ms-11 col-11 mx-auto"
			>
				<div class="deserve text-center">
					<h2 class="textcolor1 weight500 medium size55 mb30">
						You Deserve The Best Team By Your Side. <br />
						So We Built One For You.
					</h2>
					<p class="textcolor1 size20">
						Large Enough To Tackle Any Project. Small Enough To Keep It
						Personal.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- deserve section ends-->
<!-- Things section starts-->
<section id="section3" class="things-section bannerdrk position-relative">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
			>
				<div class="header text-center">
					<h2 class="text-white weight500 medium size55 mb30">
						Six Things You Should Know <br />About Pixtar
					</h2>
				</div>
				<div id="section-target" class="things" id="oneth" #targetSection>
					<div class="scroll-track">
						<div class="track-item pt-0">
							<div class="number-wrapper">
								<img
									src="{{ baseUrl }}/img/about-us/zero1.png"
									alt="About Pixtar Studio"
									width=""
									height=""
									loading="lazy"
								/>
							</div>
							<div class="text-wrapper">
								<p class="size32 text-white mb-3">We Looove What We Do</p>
								<p class="text-white size24">
									We’re not just designers; we’re creators who live and breathe
									design. The kind of team that sparks with new ideas even
									during a weekend coffee run. Your project isn’t just work—it’s
									what we love to do.
								</p>
							</div>
						</div>
						<div class="track-item">
							<div class="number-wrapper">
								<img
									src="{{ baseUrl }}/img/about-us/zero2.png"
									alt="Design and Branding Studio"
									width=""
									height=""
									loading="lazy"
								/>
							</div>
							<div class="text-wrapper">
								<p class="size32 text-white mb-3">Conversion-Focused Design</p>
								<p class="text-white size24">
									Beautiful design that goes beyond aesthetics. We craft visuals
									that captivate, influence, and drive action, helping you
									connect with customers and achieve real results.
								</p>
							</div>
						</div>
						<div class="track-item">
							<div class="number-wrapper">
								<img
									src="{{ baseUrl }}/img/about-us/zero3.png"
									alt="Web Development Studio"
									width=""
									height=""
									loading="lazy"
								/>
							</div>
							<div class="text-wrapper">
								<p class="size32 text-white mb-3">People First, Always</p>
								<p class="text-white size24">
									Every project we take on starts with people. We believe that
									respect, care, and collaboration make great design possible.
									When we work together, creativity flourishes.
								</p>
							</div>
						</div>
						<div class="track-item">
							<div class="number-wrapper">
								<img
									src="{{ baseUrl }}/img/about-us/zero4.png"
									alt="Creative Design Studio Dubai"
									width=""
									height=""
									loading="lazy"
								/>
							</div>
							<div class="text-wrapper">
								<p class="size32 text-white mb-3">A Team Of Superpowers</p>
								<p class="text-white size24">
									Individually, we each have our own strengths. Together, we
									bring them all to the table—design, strategy, and
									development—to create powerful, custom solutions that stand
									out.
								</p>
							</div>
						</div>
						<div class="track-item">
							<div class="number-wrapper">
								<img
									src="{{ baseUrl }}/img/about-us/zero5.png"
									alt="Premium branding studio"
									width=""
									height=""
									loading="lazy"
								/>
							</div>
							<div class="text-wrapper">
								<p class="size32 text-white mb-3">Details That Matter</p>
								<p class="text-white size24">
									Our commitment to detail means peace of mind for you. From
									concept to launch, we meticulously refine every aspect of your
									brand or website, ensuring everything is intentional and
									perfectly crafted.
								</p>
							</div>
						</div>
						<div class="track-item" #lastSection id="last-section">
							<div class="number-wrapper">
								<img
									src="{{ baseUrl }}/img/about-us/zero6.png"
									alt="team of creators"
									width=""
									height=""
									loading="lazy"
								/>
							</div>
							<div class="text-wrapper" id="sixth">
								<p class="size32 text-white mb-3">Here For The Journey</p>
								<p class="text-white size24">
									We’re all about building designs that stand the test of time.
									Think of us as your long-term creative partner—ready to grow
									with you, committed to your success, and always here to help
									bring your vision to life.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- Things section ends-->
<!-- business section ends-->
<section class="business position-relative">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
			>
				<div class="wrapper position-relative">
					<div class="imgbox">
						<img
							src="{{ baseUrl }}/img/about-us/kbn.png"
							alt="long-term creative partner"
							class="img-fluid"
							width=""
							height=""
							loading="lazy"
						/>
					</div>
					<div class="box1 text-center">
						<p class="textcolor1 mb-5 size32 lufgalight">
							“If you want a partner who gets you, knows your business, and is
							on <span class="d-block"> your side 100%—look no further.”</span>
						</p>
						<h2 class="textcolor1 size32 bold">KBN</h2>
						<h3 class="textcolor1 mt-0 size24 bold">CEO & Creative Director</h3>
					</div>
					<div
						class="bottomtext d-flex justify-content-center position-relative"
					>
						<h2 class="size55 medium textcolor1 mt-0 text-center">
							We’ll be your partner <br />
							in your journey
						</h2>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="linkToPackages">
		<a
			href="/contact"
			type="button"
			class="d-flex justify-content-start align-items-center"
		>
			<span class="text semibold text-capitalize"> Let’s Begin </span>
			<!--<i class="fa fa-chevron-right" aria-hidden="true"></i> -->
			<lucide-icon name="chevron-right" class="lucide-arrow-icon"></lucide-icon>
			<span class="borderspan"> </span>
		</a>
	</div>
</section>
<!-- <div class="action position-relative mbrem5 mtrem3">
	<div class="position-absolute start-50 translate-middle">
		<p>
			<a href="/contact" class="cstbtn cstbtn128 ftr1">
				<span class="text semibold"> Let’s Begin</span>
				<span class="borderspan"
					><i class="fa fa-chevron-right" aria-hidden="true"></i>
				</span>
			</a>
		</p>
	</div>
</div> -->

<!-- business section ends-->
<!-- Successful story sections-->
<!-- <section class="success-story bannerdrk">
	<div class="container">
		<div class="row">
			<div class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto">
				<div class="content mbrem8">

				</div>
				<owl-carousel-o [options]="desktopslider">
					<ng-container>
						<ng-template carouselSlide [id]="baseUrl">
							<div class="col-md-9 col-sm-11 col-11 mx-auto">
								<div class="row justify-content-center">
									<div class="col-lg-3 col-md-5 col-sm-5">
										<div class="imgblk">
											<img class="" src="{{baseUrl}}/img/home/hiral-story-2.png" alt="Branding studio Dubai">
										</div>
									</div>
									<div class="col-lg-8 col-md-7 offset-lg-1 col-sm-7 mt-sm-0 mt-3">
										<div class="slidecontent">
											<p class="fontsize12 textcolor1 text-white">Hiral Krupesh . Founder & Creative Director . Carat
												Craft
												Jewellery</p>
											<h4 class="size32 textcolor1 mt-0 mb30 text-white">I HIGHLY RECOMMEND PIXTAR IF YOU ARE LOOKING TO
												REVAMP AND
												ELEVATE YOUR BRAND</h4>
											<p class="size18 textcolor3 d-md-block d-sm-none d-none text-white">“ Lorem ipsum dolor sit amet,
												consetetur sadipscing elitr, sed diam
												nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
												vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
												sanctus est.”</p>
										</div>
									</div>
									<div class="col-md-12 d-md-none d-sm-block d-block  mt-sm-4 mt-3 ">
										<div class="slidecontent">
											<p class="size18 textcolor3 text-white">“ Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
												sed diam
												nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
												vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
												sanctus est.”</p>
										</div>
									</div>
								</div>
							</div>
						</ng-template>
						<ng-template carouselSlide [id]="baseUrl">
							<div class="col-md-9 col-sm-11 col-11 mx-auto">
								<div class="row justify-content-center">
									<div class="col-lg-3 col-md-5 col-sm-5">
										<div class="imgblk">
											<img class="mx-auto" src="{{baseUrl}}/img/home/crystal-story.png" alt="Best team by your side">
										</div>
									</div>
									<div class="col-lg-8 col-md-7 offset-lg-1 col-sm-7 mt-sm-0 mt-3">
										<div class="slidecontent">
											<p class="fontsize12 textcolor1 text-white">Hiral Krupesh . Founder & Creative Director . Carat
												Craft
												Jewellery</p>
											<h4 class="size32 textcolor1 mt-0 mb30 text-white">I HIGHLY RECOMMEND PIXTAR IF YOU ARE LOOKING TO
												REVAMP AND
												ELEVATE YOUR BRAND</h4>
											<p class="size18 textcolor3 d-md-block d-sm-none d-none text-white">“ Lorem ipsum dolor sit amet,
												consetetur sadipscing elitr, sed diam
												nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
												vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
												sanctus est.”</p>
										</div>
									</div>
									<div class="col-md-12 d-md-none d-sm-block d-block mt-sm-4 mt-3">
										<div class="slidecontent">
											<p class="size18 textcolor3 text-white">“ Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
												sed diam
												nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
												vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
												sanctus est.”</p>
										</div>
									</div>
								</div>
							</div>
						</ng-template>
					</ng-container>
				</owl-carousel-o>

			</div>
		</div>
	</div>
</section> -->
<app-testimonial></app-testimonial>
<!-- Successful story sections-->

<!-- Faq section Starts -->
<!-- <section class="section bannerdrk faqsection">
	<div class="container">
		<div class="row">
			<div class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto">
				<div class="row">
					<div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
						<div class="creative">
							<h1 class="">
								What <br /> makes Pixtar <br /> Special? <br /> <span> And other FAQs… </span>
							</h1>
						</div>
					</div>
					<div class="col-lg-7 offset-lg-1 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1000"
						data-aos-delay="100">
						<div class="d-block ">
							<div class="custom-collapse footer-collapse">
								<div class="accordion" id="accordionExample1">
									<div class="accordion-item">
										<h2 class="accordion-header" id="headingOne">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
												Alright, no secrets – what makes Pixtar stand out?
											</button>
										</h2>
										<div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
											data-bs-parent="#accordionExample1">

											<div class="accordion-body">
												Pixtar stands out for our unique blend of creativity, strategy, and a deep commitment to client
												satisfaction. We don’t just design; we craft memorable, user-friendly experiences that make
												brands shine.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h2 class="accordion-header" id="headingThree">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
												Where are you based?
											</button>
										</h2>
										<div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												Virtually, next door! We’re proudly based in Dubai, UAE, but our team collaborates with clients
												worldwide, making distance no barrier to outstanding design!

												Our business hours are 9 am–6 pm GST / 1 am–10 am EST / 10 pm–7 am PST. But with our
												early-rising CEO and night-owl CTO, we’re always able to sync up with clients from LA all the
												way to Australia—and all the lovely places in between.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h2 class="accordion-header" id="headingFour">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
												How are you different from a freelance designer?
											</button>
										</h2>
										<div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												At Pixtar, you get the expertise of an entire team, not just one individual. We bring together
												specialized skills in design, strategy, and development, providing a more comprehensive approach
												and smoother project delivery.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h2 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
												What other design magic do you offer?
											</button>
										</h2>
										<div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												Besides website design, we specialize in branding, UI/UX design, graphic design, and digital
												marketing assets. Whatever your design needs, Pixtar has the creative solution.
											</div>
										</div>
									</div>

									<div class="accordion-item">
										<h2 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
												Who do you usually work with?
											</button>
										</h2>
										<div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												We collaborate with businesses of all sizes—from startups to established brands—across a range
												of industries, including Lifestyle, healthcare, technology, real estate, and more.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
												Which platforms do you use for building websites?
											</button>
										</h2>
										<div id="collapseSix" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												We work with popular platforms like Angular, Node.js, React, Shopify, Magento and Webflow,
												ensuring you get a website that’s not only beautiful but also easy to manage and scalable.
											</div>
										</div>
									</div>
									<div class="accordion-item">
										<h2 class="accordion-header" id="headingSix">
											<button class="accordion-button collapsed brdbtm" type="button" data-bs-toggle="collapse"
												data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
												I’m in! When can we get started?
											</button>
										</h2>
										<div id="collapseSeven" class="accordion-collapse collapse" aria-labelledby="headingThree"
											data-bs-parent="#accordionExample1">
											<div class="accordion-body">
												We’re thrilled to have you onboard! Just reach out through our contact page, and we’ll set up a
												kickoff meeting to dive into your project.
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section> -->
<app-faq-component></app-faq-component>
<!-- Faq section ends -->
